import { Component, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { BaseAppEditComponent } from '@app/cp/shared/base-components/base-app-edit.component';
import { CommonParam } from '../../shared/models/CommonParam';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { ElementRef } from '@angular/core';
import { CommonFunctions } from '../../shared/static/common-functions';
import { MessageType } from '../../shared/enums/MessageType';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { DispatchCallbackBus } from '../../shared/models/DispatchCallbackBus';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'dispatch-callback',
    templateUrl: './dispatch-callback.component.html',
    styleUrls: ['./dispatch-callback.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchCallbackComponent extends BaseAppEditComponent<DispatchCallbackBus, DispatchesService>  {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: DispatchesService) {
        super(globals, qry_rd);
        this.appCode = "DispatchCallback";
        this.svc_data = svc_data;
//        this.saveMode = SaveMode.all;
        this.className = "DispatchCallbackBus";
        //    this.createForm();

    }
    @Input() localSaveMode: number = 1; //1-Normal, 2-Local Save
    @Input() mode: number = 1; //1-Normal, 2-Popup
    @Input() data: DispatchCallbackBus = new DispatchCallbackBus(null);
    @Input() addtlData: any; //AdditionalDispatchData. AdditionalDispatchDataQV;
    protected _Id: any; //dispatchid input
    @Input() set Id(value: any) {
        if (value != this._Id) {
            if (CommonFunctions.hasGuidValue(value)) {
                this._Id = value;
                this.getData();
            }
            else {
                this.clear();
            }
        }
    }
    protected _active: boolean = false;
    @Input() set active(value: boolean) {
        this.beforeActiveSet(value);
        this._active = value;
    }

    get active(): boolean {
        return this._active;
    }
    beforeActiveSet(value: boolean) {

    }
    clear() {
        super.clear();
        this._Id = null;
        this.data = this.createNew(null);
    }
    protected _reasonElemElemRef: ElementRef;
    @ViewChild('reasonElem') set reasonElem(content: ElementRef) {
        if (content) { // initially setter gets called with undefined

            this._reasonElemElemRef = content;
        }
    }
    cbSystemIdNoteChanged(e: any) {
        console.log("disp-cb: ", e);
        this.dataChanged(e);
    }

    isDirtyFlag: boolean = false;
    get canSave(): boolean {
        let okToSave: boolean = false;

        if (this.isDirtyFlag) {
            okToSave = true;
        }

        return okToSave;
    }
    close(data: any = null, clear: boolean = true) {
        super.close(data, clear);
        this.isDirtyFlag = false;
    }

    cancel() {
        this.close(null, false);
    }
    dataChanged(e: any) {

        this.isDirtyFlag = true;
        if (this.localSaveMode == 1) {
            let data = this.getDataForSave();
            this.sendParentMessage(MessageType.changed, null, null, null, data);
        }
        //this.send
    }
    getDataForSave(): CommonParam {
        let param: CommonParam = new CommonParam();
        param.addParam("Data", this.data);
        return param;
    }

    showStatus: boolean = false;
    saveIndividual() {
        let param: CommonParam = new CommonParam();
        param.addParam("CallbackSystemIdNote", this.data.callbackSystemIdNote);
        this.svc_data.saveCallbackTab(this.data.dispatchId, param).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {

                this.saveSuccess("Invoice Dispute Credit Memo Required Info Successfully Saved")
                this.close(param, false);
            }
            else {
                this.saveError(info.message);
            }
        });
    }

    getData() {
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.getCallbackInfo(this._Id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.data = new DispatchCallbackBus(info.primaryReturn);
                console.log("callback->agd: ", info, this.data, this);
            }
        })
    }

    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok) {
            this.dataChanged(null);
        }
    }
}

